import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.user')
  .factory('$user', UserObjectFactory);

/* @ngInject */
function UserObjectFactory($bringozFactory: $bringozFactory,
                           UsersAPI: BringozApi,
                           User_DS: DataStoreConfig) {
  function $user(id: string) {
    return $bringozFactory(id, UsersAPI, User_DS);
  }

  return $user;
}
